import { ButtonRoundedSm } from '@apps-common/components/elements'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS, productIsSupported } from '@apps-common/config/product-codes'
import { invalidateScheduleQueries } from '@apps-common/lib/invalidateScheduleQueries'
import { useState } from 'react'
import { FORM_SCHEDULE_MODIFY, ScheduleModifyForm } from './ScheduleModifyForm'

export interface IScheduleModifyModalProps {
  status: string
  unitId: string
  productId: string
  scheduleId?: number
}

export const ScheduleModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IScheduleModifyModalProps
}) => {
  const { unitId, productId, scheduleId } = componentProps
  const [loading, setLoading] = useState<boolean>(false)
  const [updating, setUpdating] = useState<boolean>(false)
  const isEditing = !!scheduleId && !Number.isNaN(scheduleId)
  const supported = productIsSupported(productId, CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS)

  return (
    <ModalContainer alwaysMobile innerClasses='sm:!h-auto'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={isEditing ? 'Update' : 'Create'} title='Schedule' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='pt-[80px]'>
        <ScheduleModifyForm
          unitId={unitId}
          productId={productId}
          scheduleId={scheduleId}
          showSubmit={false}
          onSave={() => {
            invalidateScheduleQueries()
            onDismiss(null, ModalDismiss.Confirm)
          }}
          onLoading={setLoading}
          onUpdating={setUpdating}
        />
      </ModalBody>
      {supported && (
        <ModalFooter>
          <div className='flex items-center justify-between gap-2'>
            <ButtonRoundedSm
              type='submit'
              form={FORM_SCHEDULE_MODIFY}
              loading={loading || updating}
              text={isEditing ? 'Update' : 'Create'}
              className='action-success'
            />
            <ButtonRoundedSm
              type='button'
              loading={updating}
              text='Cancel'
              className='action-neutral'
              callback={() => onDismiss(null, ModalDismiss.Cancel)}
            />
          </div>
        </ModalFooter>
      )}
    </ModalContainer>
  )
}
